import { useLocalStorage } from '@vueuse/core'

interface CompareUnit {
    projectId: number
    buildingId: number
    unitId: number
}

export function useCompare(projectId?: number) {
    const getStorageKey = (pId: number) => `visuado_compare_project_${pId}`

    const currentProjectId = ref<number | null>(projectId || null)

    const compareUnits = computed(() => {
        if (!currentProjectId.value) return []
        return useLocalStorage<CompareUnit[]>(getStorageKey(currentProjectId.value), []).value
    })

    const addtoCompare = async (projectId: number, buildingId: number, unitId: number) => {
        currentProjectId.value = projectId
        const storage = useLocalStorage<CompareUnit[]>(getStorageKey(projectId), [])

        // Check if unit is already in the list
        if (!storage.value.find((unit: CompareUnit) => unit.unitId === unitId)) {
            storage.value.push({ projectId, buildingId, unitId })
        }
    }

    const removeFromCompare = async (projectId: number, unitId: number) => {
        const storage = useLocalStorage<CompareUnit[]>(getStorageKey(projectId), [])
        storage.value = storage.value.filter((unit: CompareUnit) => unit.unitId !== unitId)
    }

    const fetchCompareUnits = async (projectId: number) => {
        currentProjectId.value = projectId
    }

    const isUnitCompare = (projectId: number, unitId: number) => {
        const storage = useLocalStorage<CompareUnit[]>(getStorageKey(projectId), [])
        if (!storage.value) {
            return false
        }
        return storage.value.some((unit: CompareUnit) => unit.unitId === unitId)
    }

    const toggleCompare = (projectId: number, buildingId: number, unitId: number) => {
        const storage = useLocalStorage<CompareUnit[]>(getStorageKey(projectId), [])
        if (storage.value.some((unit: CompareUnit) => unit.unitId === unitId)) {
            removeFromCompare(projectId, unitId)
        } else {
            addtoCompare(projectId, buildingId, unitId)
        }
    }

    const clearCompare = (projectId: number) => {
        const storage = useLocalStorage<CompareUnit[]>(getStorageKey(projectId), [])
        storage.value = []
    }

    return {
        compareUnits,
        addtoCompare,
        removeFromCompare,
        fetchCompareUnits,
        isUnitCompare,
        toggleCompare,
        clearCompare,
        getStorageKey
    }
}
